import { Form } from "react-bootstrap";

export const ReadOnlyInput = ({ label, value }) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      <Form.Control type="text" defaultValue={value} disabled readOnly />
    </Form.Group>
  );
};
